// extracted by mini-css-extract-plugin
export default {"root":"_1NBHJtEo","title":"_2-o2ZTD5"};